// extracted by mini-css-extract-plugin
export default {"root":"Message_root__F51XI","message":"Message_message__fh13J","description":"Message_description__9iVsV"};